const IPV4_PATTERN = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
const HEXTET_PATTERN = /^[0-9a-fA-F]{1,4}$/;

function isValidIpv6(value: string): boolean {
  if (value === '::') return true;
  const halves = value.split('::');
  if (halves.length > 2) return false;
  const groups = halves.map((half) => (half === '' ? [] : half.split(':')));
  for (const half of groups) {
    for (const hextet of half) {
      if (!HEXTET_PATTERN.test(hextet)) return false;
    }
  }
  const total = groups.reduce((count, half) => count + half.length, 0);
  // A `::` stands in for at least one zero group; without it all eight must be present.
  return halves.length === 2 ? total <= 7 : total === 8;
}

/**
 * Accepts a single literal IPv4 or IPv6 address — no CIDR ranges, mirroring
 * the API's own validation of declared egress addresses (the edge access
 * control's authorized list holds literal addresses, so a range could never
 * be verified against it entry by entry).
 */
export function isValidIpAddress(value: string): boolean {
  if (value.includes('/')) return false;
  return IPV4_PATTERN.test(value) || (value.includes(':') && isValidIpv6(value));
}
